import { useEffect, useState } from 'react';
import {
  getCachedDemItemImageUrl,
  resolveDemItemImageUrl,
  setCachedDemItemImageUrl,
} from '../lib/demItemImage';

export function useDemItemImageUrl(imageUrl?: string | null): string | null {
  const stored = imageUrl?.trim() ?? '';

  const [url, setUrl] = useState<string | null>(() =>
    stored ? getCachedDemItemImageUrl(stored) : null,
  );

  useEffect(() => {
    if (!stored) {
      setUrl(null);
      return;
    }

    const cached = getCachedDemItemImageUrl(stored);
    if (cached) {
      setUrl(cached);
      return;
    }

    let cancelled = false;

    void resolveDemItemImageUrl(stored).then((resolved) => {
      if (cancelled) return;
      if (resolved) setCachedDemItemImageUrl(stored, resolved);
      setUrl(resolved);
    });

    return () => {
      cancelled = true;
    };
  }, [stored]);

  return url;
}
